import React, { useState, useEffect } from 'react';
import vserveLogo from '../assets/images/vserve-one-img.png';
import { replace, useNavigate, useParams } from 'react-router-dom';
import { blogPosts } from '../constants/helper';
import useScrollToTop from './scrollToTop';
import Markdown from 'markdown-to-jsx';

const BlogPostComponent = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [darkMode, setDarkMode] = useState(false);
    const [post, setPost] = useState(null);
    const navigate = useNavigate();
    const { slug } = useParams();
    useScrollToTop();

    useEffect(() => {
        setTimeout(() => setIsLoaded(true), 100);
        const isDark = localStorage.getItem('darkMode') === 'true';
        setDarkMode(isDark);
        if (isDark) {
            document.documentElement.classList.add('dark');
        }

        // Find the post based on the slug
        const createSlug = (text) => {
            return text
                .toLowerCase()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/--+/g, '-')
                .trim();
        };

        const foundPost = blogPosts.find((p) => createSlug(p.heading) === slug);

        if (foundPost) {
            setPost(foundPost);
        } else {
            navigate('/certainly');
        }
    }, [slug, navigate]);

    // const handleBackClick = () => {
    //     navigate('/certainly');
    // };

    if (!post) return null;

    const toggleDarkMode = () => {
        const newDarkMode = !darkMode;
        setDarkMode(newDarkMode);
        localStorage.setItem('darkMode', newDarkMode);
        document.documentElement.classList.toggle('dark');
    };

    const backToBlogPage = () => {
        navigate('/certainly', { replace: true });
    };

    return (
        <div
            className={`min-h-screen font-archivo transition-all duration-500 ease-in-out transform 
            } ${darkMode ? 'bg-gray-900' : 'bg-white'}`}
        >
            {/* Header with slide-down animation */}
            <header
                className={`border-b sticky top-0 z-50 transition-all duration-500 transform ${
                    isLoaded
                        ? 'translate-y-0 opacity-100'
                        : '-translate-y-6 opacity-0'
                } ${
                    darkMode
                        ? 'bg-black border-gray-700'
                        : 'bg-black border-gray-100'
                }`}
            >
                <div className='pr-4 pb-2 md:pb-0 flex justify-between items-center'>
                    <div className='flex items-center'>
                        <div
                            className='flex flex-col md:flex-row items-center gap-2 md:gap-8 font-sansation cursor-pointer'
                            onClick={backToBlogPage}
                        >
                            <div
                                className={`certainly-header text-lg font-bold px-8 py-2 bg-gradient-to-r from-[#0b6513] via-[#16be51] to-[#16b360] text-white`}
                            >
                                CERTAINLY !
                            </div>
                            <div className='text-xs md:text-xl flex items-center gap-4 ml-2 md:ml-0'>
                                <img
                                    src={vserveLogo}
                                    alt='Vserve.One Logo'
                                    className='max-w-32 md:max-w-36'
                                />
                            </div>
                        </div>
                    </div>
                    <button
                        onClick={toggleDarkMode}
                        className={`p-2 rounded-lg transition-colors duration-300 ${
                            darkMode
                                ? 'bg-gray-800 hover:bg-gray-700 text-yellow-400'
                                : 'bg-gray-800 hover:bg-gray-700 text-white'
                        }`}
                        aria-label='Toggle dark mode'
                    >
                        {darkMode ? (
                            <svg
                                className='w-5 h-5'
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                            >
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth='2'
                                    d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z'
                                />
                            </svg>
                        ) : (
                            <svg
                                className='w-5 h-5'
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                            >
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth='2'
                                    d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
                                />
                            </svg>
                        )}
                    </button>
                </div>
            </header>
            <section
                className={`md:px-24 lg:px-44 px-4 pt-12 md:pt-24 transition-all duration-500 ease-in-out transform ${
                    isLoaded
                        ? 'translate-y-0 opacity-100'
                        : 'translate-y-6 opacity-0'
                } ${
                    darkMode
                        ? 'bg-gradient-to-b from-green-800 to-gray-900'
                        : 'bg-gradient-to-b from-green-100 to-white'
                }`}
            >
                {/* <button
                    onClick={handleBackClick}
                    className={`mr-4 mb-12 rounded-lg transition-colors duration-300 flex gap-4 ${
                        darkMode
                            ? 'text-white hover:text-green-600'
                            : 'text-gray-600 hover:text-gray-900'
                    }`}
                >
                    <svg
                        className='w-6 h-6'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                    >
                        <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M10 19l-7-7m0 0l7-7m-7 7h18'
                        />
                    </svg>
                    <p>Back to Blog Page</p>
                </button> */}
                <div className='mb-12 md:mb-24'>
                    <h1
                        className={`font-sansation text-4xl md:text-5xl mb-4 leading-tight transition-all duration-700 transform ${
                            isLoaded
                                ? 'translate-y-0 opacity-100'
                                : 'translate-y-6 opacity-0'
                        } ${darkMode ? 'text-white' : 'text-gray-900'}`}
                    >
                        <p>{post.heading}</p>
                        <br />
                        <p
                            className={`font-sansation w-full md:w-full lg:w-3/5 text-2xl md:text-4xl lg:text-3xl leading-tight bg-clip-text ${
                                isLoaded
                                    ? 'translate-y-0 opacity-100'
                                    : 'translate-y-6 opacity-0'
                            } ${
                                darkMode
                                    ? 'bg-gradient-to-r from-[#16c43e] via-[#8dd0a5] to-[#fafdfb] text-transparent'
                                    : 'text-black'
                            }`}
                        >
                            {post.translation} <br></br>
                            {post.subtitle}
                        </p>
                    </h1>
                </div>
            </section>

            <main key={post.id} className='md:pt-0'>
                <div className='md:flex-col lg:flex gap-8 md:px-24 lg:px-44 px-4 max-w-8xl'>
                    {post?.mainImage && (
                        <div className='w-full lg:w-3/5'>
                            <img
                                src={post.mainImage || ''}
                                alt={post.title || ''}
                                className={`w-full rounded-xl shadow-lg mb-4 md:mb-12 transition-all duration-700 delay-300 transform ${
                                    isLoaded
                                        ? 'translate-y-0 opacity-100'
                                        : 'translate-y-12 opacity-0'
                                }`}
                                loading='lazy'
                            />
                        </div>
                    )}
                    <div className='md:w-full'>
                        <div className='flex items-center space-x-4 mb-4'>
                            <span className='text-green-600 font-medium text-sm'>
                                {post.category}
                            </span>
                            <span
                                className={`text-sm transition-colors duration-300 ${
                                    darkMode ? 'text-gray-400' : 'text-gray-600'
                                }`}
                            >
                                {post.readTime}
                            </span>
                        </div>

                        <div className='flex items-center space-x-4 mb-8'>
                            <div>
                                <div
                                    className={`text-sm font-medium ${
                                        darkMode
                                            ? 'text-[#00FF91]'
                                            : 'text-black text-2xl'
                                    }`}
                                >
                                    {post.author}
                                </div>
                                <div
                                    className={`text-sm ${
                                        darkMode
                                            ? 'text-gray-400'
                                            : 'text-gray-500'
                                    }`}
                                >
                                    {post.date}
                                </div>
                            </div>
                        </div>

                        <article className='font-lato'>
                            {post.content.map((section, index) => (
                                <p
                                    key={index}
                                    className={`leading-relaxed text-lg mb-6 ${
                                        darkMode
                                            ? 'text-gray-100'
                                            : 'text-black'
                                    }`}
                                >
                                    <Markdown>{section.text}</Markdown>
                                </p>
                            ))}
                        </article>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer
                className={`border-t py-4 transition-all duration-500 transform ${
                    isLoaded
                        ? 'translate-y-0 opacity-100'
                        : 'translate-y-6 opacity-0'
                } ${
                    darkMode
                        ? 'bg-black border-gray-700'
                        : 'bg-black border-gray-100'
                }`}
            >
                <div className='container mx-auto px-4 text-center'>
                    <div
                        className={`${
                            darkMode ? 'text-gray-400' : 'text-white'
                        }`}
                    >
                        © 2025 VServe.One. All rights reserved.
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default BlogPostComponent;
